//login
export const Login = '/users/login/'

export const Refresh = '/users/token/refresh/'

export const VerifyOtp = '/users/verify-otp/'
export const CheckUser = '/users/check-user/'
export const ForgotPassword = '/users/create-password/'

export const userManagementGet = 'users/users_api/user/'

export const ResetPassword = 'users/reset-password/'

//user Managmenet API's
export const GetUsers = 'users/users_api/user/'
export const exportUsers = 'users/users_api/user/download_users_xlsx'
export const getPaginatedUsers = 'users/get_users_list'

export const Divisions = 'documents/entity/'


//BankTransactions
export const MutlipleAssignTxnUser = 'bankmanagement/multiple_assign_transactions_to_user/'

// This will give both Broker Branches and Broker Names
export const BrokerList = 'documents/get_broker_list/'

export const getBrokerBranchDetailsByBrokerBranchName = 'documents/get_broker_by_broker_branch_name/'

export const UniqueCurrencyList = 'documents/get_all_unique_bank_names'

export const CurrencyList = 'documents/currency_details/'
export const BankList = 'documents/get_banks_list/'
export const GetDetailsByBank = 'documents/get_details_by_bank/?bank_name='
export const BankTransaction = 'bankmanagement/bank_transaction/'
export const UserAssignTxn = 'bankmanagement/user_assign_transactions/'
export const getBanlTransactionDetailsURL = 'bankmanagement/get_bankdetails_by_txn_id/?txn_id='
export const getEMailWorkFlowDocs = 'bankmanagement/get_Email_docs_by_txn_id/?txn_id='

//Work list Actions
export const workListTableData = 'bankmanagement/get_workflow_list_id/'

export const getCashAllocationWriteOffURL = 'bankmanagement/cash_allocation_writeoff/'
export const getCashAllocationRefundURL = 'bankmanagement/cash_allocation_refund/'
export const getCashAllocationCorrectiveTransferURL = 'bankmanagement/cash_allocation_corrective/'
export const getCashAllocationCorrectionTypeURL = 'documents/correction_type/'
export const getCashAllocationCrossAllocationURL = 'bankmanagement/cross_allocation/'
export const getCashAllocationCFIURL = 'bankmanagement/cash_allocation_cfi/'
export const getPaymentNoVarianceURL = 'payment/exception_file/'

//Workflow
export const workflowBankTransaction = 'bankmanagement/workflow_bank_transactions/'

export const getBankTxnWorkflowStatus = `bankmanagement/bank_transaction_workflow_status_check/?`;

export const getWorkflowList = `bankmanagement/workflow/`

export const workstepUserUpdate = `bankmanagement/workstep_user_update/`

//cash Tracker
export const getCashTracker = "bankmanagement/get_cash_tracker/"
export const getCashTrackerReport = "bankmanagement/export_cash_tracker_report/"

//Enity Table Maintainance
export const EntityTableMaintainance = 'documents/entity/'

//LOB Table Maintainance

export const LOBTableMaintainance = 'documents/lob/'

//SCM Table  Maintainance
export const SCMTableMaintainance = 'documents/scm_partners/'

//Binding Agreements
export const BindingAgreements = 'documents/binding_agreement/'

//Correction Type Table Maintainance
export const CorrectionTypeTableMaintainance = 'documents/correction_type/'

//allocation Status

export const AllocationStatus = 'documents/allocation_status/'

// Broker Table Maintainance

export const Broker = 'documents/broker_info/'

//cash transfer 

export const CashTransfer = 'documents/cash_transfer/'

//policy

export const Policy = '/documents/policy_type/'

//actions

export const Action = '/documents/agedebt_action/'

//category

export const Category = '/documents/agedebt_category/'

//currency 

export const CurrencyTable = 'documents/currency_details/'

// bank exchange 

export const BankExchangeRateAPI = 'documents/exchange_rate/'
export const ROEFILTERAPI = 'documents/get_ROE_list/'

//Premium Table

export const PremiumTable = 'documents/bank_data/'

//Upload Files

export const UploadFile = "bankmanagement/bank_reconciliation/"

//Upload Files 
export const uploadRbsDetails = "documents/rbs_details/"
export const uploadSiriusData = "documents/sirius_data/"
export const uploadAonLedger = "documents/aon_ledger/"
export const uploadMopMapping = "documents/mop_mapping/"
export const getUpLoadedBankFiles = "bankmanagement/upload_bank_files/"
export const uploadROEFiles = "documents/roe_file_upload/"

//Bank Reconciliation
export const getBankReconciliationTable = "bankmanagement/bank_reconciliation_accountno/"


export const cashAllocationLockedUnlocked = "bankmanagement/cash_allocation_locked_unlocked/"

export const getCashAllocationLockedUnlocked = "bankmanagement/cash_allocation_locked_unlocked_history/"

// BDX Payment Updates
export const premiumBDX = "payment/premium_bdx_report/"
export const premiumBDXDemoSummary = "payment/premium_bdx_demo_summary/"
export const premiumBDXMatchDetail = "payment/premium_bdx_match_detail/"
export const premiumBDXExport = "payment/premium_bdx_export/"
export const premiumBDXReadData = "payment/read-data/"
export const premiumBDXFile = "payment/premium_bdx_file/"
export const payment="payment/payment_file/"
export const paymentTreasury="payment/payment_treasury/"
export const exceptionReport="payment/exception_file/"
export const getPayoutSummary="payment/payout_summary/"
// export const ViewBDXPaymentSheet="payment/view_premium_bdx_sheet/"

export const getAllPaymentIds="payment/get_all_paymentid"

// Dashboard
export const DashboardHeader = "bankmanagement/dashboard/"
export const BankBalanceDashboardHeader = "bankmanagement/dashboard_bank_balance/"
export const BankNameHeader = "bankmanagement/get_bank_names/"
export const BankAccountHeader = "bankmanagement/get_bank_account_based_on_bank_name/"

//Policy File Upload //May 19 2024 by Aparajita
export const PolicyFileUpload="documents/policy_data_excel_import/"

//Admin SLA Table
export const SLATableMaintainance = 'documents/sla/'

export const ParticipatingInsurer = 'documents/participating_insurer/'

export const Escalation = 'documents/escalation/'

// Accounting Month APIs
export const getAccountingMonths = "bankmanagement/accounting_month_end/"

//Txn Category
export const TxnCategoryTableMaintainance = 'documents/transaction_category/'
// File Management
export const getFIles = 'filemanagement/files/'

// Txn Status
export const TxnStatusTableMaintainance = 'documents/txn_status/'
export const fetchFile = 'bankmanagement/download/'

// Aged Debt Due
export const AgedDebtDueAPI = 'documents/aged_debt_due/'
export const AgedDebtDueManagementAPI = 'documents/aged_debt_due_management/'

// Aged Report Listing
export const AgedReports = "documents/aged_report_data"
export const RunAgeDeptReport = "documents/run_age_dept_report/"
export const DownloadPolicyData = "documents/download_policy_data"
export const GetAgedDeptYears = "documents/get_aged_dept_years"
export const GetCalculationFiles = "documents/get_calulation_files_list"
export const GetAgedeptDetails = "documents/get_agedept_details"

// Chaser Indicator
export const ChaserIndicator = "documents/chaser_indicator/"
export const Chaser = "bankmanagement/chaser/"

export const downloadBrokerInfo = 'documents/download_broker_info/'
export const downloadBindingAgreement = 'documents/download_binding_agreement/'
export const downloadCorrectionType = 'documents/download_correction_type/'
export const downloadCorrectiveTransfer= 'documents/download_corrective_transfer/'
export const downloadAllocationStatus = 'documents/download_allocation_status/'
export const downloadCurrency = 'documents/download_currency_details/'
export const downloadExchangeRate = 'documents/download_exchange_rate/'
export const downloadBankInfo = 'documents/download_bank_info/'
export const downloadEntity = 'documents/download_entity/'
export const downloadLOB = 'documents/download_lob/'
export const downloadPolicyType = 'documents/download_policy_type/'
export const downloadSCMPartners = 'documents/download_scm_partners/'
export const downloadParticipatingInsurer = 'documents/download_participating_insurer/'
export const downloadEscalation = 'documents/download_escalation/'
export const downloadTxnCategory = 'documents/download_transaction_category/'
export const downloadAccountingMonths = "bankmanagement/download_accounting_month_end/"
export const downloadTxnStatus = 'documents/download_txn_status/'
export const downloadFiles = 'filemanagement/download_files/'
export const assignPolicyHandlerAPI = 'bankmanagement/assign_policy_handler/'
export const GetEmailList = 'documents/read_email_list/'
export const SendEmail = 'documents/send_reply_email/'
export const userPermissionAPI = 'users/users_api/user_permissions/'

// Workflow Dashboard APIs
export const GetWorkflowDashboardSummary = 'bankmanagement/workflow_dashboard/summary/'
export const GetAgingAnalysis = 'bankmanagement/workflow_dashboard/aging_analysis/'
export const GetWorkflowTypeBreakdown = 'bankmanagement/workflow_dashboard/workflow_type_breakdown/'
export const GetWorkflowOverview = 'bankmanagement/workflow_dashboard/overview/'
export const GetTeamActivity = 'bankmanagement/workflow_dashboard/team_activity/'
export const GetPendingWorkflowDetails = 'bankmanagement/workflow_dashboard/pending_details/'